var map = {
	"./webspecial_event_konzert_cn.webm": 4100,
	"./webspecial_event_konzert_de.webm": 5513,
	"./webspecial_event_konzert_en.webm": 1438,
	"./webspecial_event_konzert_ja.webm": 2212
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9292;